import { render } from "./TaskAssignment.vue?vue&type=template&id=36d7b682"
import script from "./TaskAssignment.vue?vue&type=script&lang=js"
export * from "./TaskAssignment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__